<template>
  <div id="engine">
    <EngineNav v-on:changeMode="changeMode($event)" />
    <EngineCardsList v-if="mode == 'cardsList'" />
    <EngineDecksList v-if="mode == 'decksList'" />
    <UserSettings v-if="mode == 'userSettings'" />
  </div>
</template>

<script>
import EngineNav from './EngineNav.vue'
import EngineCardsList from './EngineCardsList.vue'
import UserSettings from '../Settings.vue'
import EngineDecksList from './EngineDecksList.vue'

export default {
  components: {
    EngineNav,
    EngineCardsList,
    EngineDecksList,
    UserSettings
  },
  data() {
    return {
      mode: 'cardsList'
    }
  },
  methods: {
    changeMode(mode) {
      this.mode = mode
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/engine/Engine.vue